'use client';
import { cn, getRegionalUrl } from '@/lib/utils';
import { TypeInfo } from '@/types/product_page/productType';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

const ProductBreadCrumb = ({
  productName,
  allCategories,
  mainCategory,
}: {
  productName: string;
  allCategories: TypeInfo[];
  mainCategory: TypeInfo;
}) => {
  const [path, setPath] = useState<string[]>([]);
  const [display, setDisplay] = useState<string[]>([]);
  const params = useParams<{ countryCode?: string }>();

  const prevCategory = Cookies.get('prevCategory');

  useEffect(() => {
    let selectedCategory: TypeInfo | undefined;

    if (prevCategory) {
      selectedCategory = allCategories.find((cat) => cat.slug === prevCategory);
    }

    if (!selectedCategory) {
      selectedCategory = mainCategory;
    }

    if (selectedCategory) {
      const encodedProductName = encodeURIComponent(productName);
      const route = `/products/${selectedCategory.sub_category?.category?.slug}/${selectedCategory.sub_category?.slug}/${selectedCategory.slug}/${encodedProductName}`;

      const pathParts = route.split('/').filter(Boolean);
      const titleParts = [
        'Products',

        selectedCategory?.sub_category?.category?.short_title ??
          selectedCategory?.sub_category?.category?.title,

        selectedCategory?.sub_category?.short_title ??
          selectedCategory?.sub_category?.title,

        selectedCategory?.short_title ?? selectedCategory?.title,
        productName,
      ];

      setPath(pathParts);
      setDisplay(titleParts);
    }
  }, [productName, allCategories, mainCategory, prevCategory]);

  return (
    <div
      className={cn(
        `font-medium text-black/70 max-w-desktop mx-auto border-t items-start md:items-center border-black/10 z-40 text-xs md:text-sm whitespace-nowrap overflow-auto no-scrollbar flex py-4 px-4`
      )}
    >
      {display?.map((part, index) => {
        const route = '/' + path?.slice(0, index + 1).join('/');

        if (index === 0 || index === 1) return null;

        return (
          <React.Fragment key={index}>
            {index !== 0 && index !== 1 && (
              <div
                className={`flex  items-center justify-center flex-wrap ${index === 2 && 'hidden'}`}
              >
                <svg
                  className={`mx-1 md:mx-[2px] mt-[3px] md:mt-0`}
                  width="9"
                  height="10"
                  viewBox="0 0 9 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.80607 8.46799C7.8799 8.39471 7.93853 8.30756 7.97855 8.21159C8.01858 8.11554 8.03915 8.01255 8.03915 7.90854C8.03915 7.80453 8.01858 7.70154 7.97855 7.60549C7.93853 7.50952 7.8799 7.42237 7.80607 7.34909L1.50238 1.0454C1.42913 0.971563 1.34198 0.912938 1.24596 0.87291C1.14994 0.832882 1.04694 0.812315 0.942922 0.812315C0.838904 0.812315 0.735909 0.832882 0.639888 0.87291C0.543867 0.912938 0.456718 0.971563 0.383469 1.0454C0.309614 1.11868 0.250997 1.20582 0.210992 1.3018C0.170988 1.39785 0.150391 1.50084 0.150391 1.60485C0.150391 1.70886 0.170988 1.81184 0.210992 1.9079C0.250997 2.00387 0.309614 2.09102 0.383469 2.1643L6.13559 7.90854L0.383469 13.6528C0.235096 13.8012 0.151738 14.0024 0.151738 14.2122C0.151738 14.4221 0.235096 14.6233 0.383469 14.7717C0.531843 14.9201 0.733088 15.0034 0.942922 15.0034C1.15276 15.0034 1.354 14.9201 1.50238 14.7717L7.80607 8.46799Z"
                    fill="#666D80"
                  />
                </svg>
              </div>
            )}
            <Link
              href={
                path?.length === index + 1
                  ? ''
                  : getRegionalUrl(route, params?.countryCode)
              }
            >
              <p
                className={cn(
                  'md:mx-1 font-semibold text-[#666D80] text-[14px] font-proxima_font hover:underline underline-offset-2',
                  index === display.length - 1 && 'text-[#313235] font-semibold'
                )}
              >
                {part}
              </p>
            </Link>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ProductBreadCrumb;
